// import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie9';
// import 'react-app-polyfill/ie11';
import InsightsPlatformLoader from '../bundles/insights_platform/startup/InsightsPlatformLoader';
import SharedCampaignResultLoader from '../bundles/insights_platform/startup/SharedCampaignResultLoader';
import ReactOnRails from 'react-on-rails';
ReactOnRails.register({
    InsightsPlatformLoader: InsightsPlatformLoader,
    SharedCampaignResultLoader: SharedCampaignResultLoader
});
